import { render, staticRenderFns } from "./RegularForms.vue?vue&type=template&id=4323c0de&scoped=true&"
import script from "./RegularForms.vue?vue&type=script&lang=js&"
export * from "./RegularForms.vue?vue&type=script&lang=js&"
import style0 from "./RegularForms.vue?vue&type=style&index=0&id=4323c0de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4323c0de",
  null
  
)

export default component.exports